<template>
    <!--  componente de botao para abrir uma rota especifica no design, recebe: siteId (id do site) e id do post como props -->
    <div id="openDesignBtn">
        <b-tooltip
            :target="() => $refs[btnRef]"
            placement="bottom"
        >
            Abrir no design
        </b-tooltip>
        
        <button v-if="loadingDesign" class="btn btn-primario p-2 pointer item-settings-button">
            <i class="fal fa-spinner fa-spin"></i>
        </button>

        <button
            v-else
            :ref="btnRef"
            id="preview-modal--openDesignBtn"
            @click="openInDesign"
            class="btn btn-primario p-2 pointer item-settings-button"
        >
            <i class="fal fa-palette"></i>
        </button>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'DesignBtn',
    props: {
        siteId: {
            required: true,
        },
        postId: {
            required: true,
        },
        isAutoSaving: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            btnRef: 'designBtnRef',
            loadingDesign: false
        }
    },
    methods: {
        // emite o evento para o posteditor rodar o autosave, quando o post já estiver salvo então redireciona para o design
        async openInDesign() {
            if (!this.loadingDesign) {
                this.loadingDesign = true;
                this.$emit('openDesign');
            }

            if (!this.isAutoSaving && this.loadingDesign) {
                await this.redirect();
            } else {
                setTimeout(async () => {
                    await this.openInDesign();
                }, 1000);
            }
        },
        // faz a requisição para o backend para pegar a url do design e redireciona para ela
        async redirect() {
            let urlRedirect;
            const url = `${process.env.ROOT_API}/api/site/${this.siteId}/design/access?page=${this.postId}`
            const res = await axios.get(url, {
                headers: {
                    Authorization: "Bearer " + this.$session.get('jwt'),
                    "Content-Type": "application/x-www-form-urlencoded",
                }
            });

            this.loadingDesign = false;

            if (res) {
                urlRedirect = res.data.url;
                window.location.href = urlRedirect;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/OpenDesignBtn.vue